import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import _ from 'lodash';
import { GenericFilter } from 'shared';
import { NotificationService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { SharedModule } from 'shared';
import { ProjectPermissionsListComponent } from '../project-role/project-permissions-list/project-permissions-list.component';
import { GroupRoleDeleteDialogComponent } from '../project-role/group-role-delete-dialog/group-role-delete-dialog.component';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatButton } from '@angular/material/button';
import { GroupRoleClaimsDialogComponent } from '../project-role/group-role-claims-dialog/group-role-claims-dialog.component';
import { ProjectGroupRoleDto } from 'shared';

// import { TenantPermissionsComponent } from '../tenant-permissions/tenant-permissions.component';
// import { DeleteTenantGrouproleDialogComponent } from '../delete-tenant-grouprole-dialog/delete-tenant-grouprole-dialog.component';
// import { TenantsButtonRendererComponent } from '../../tenants-button-renderer/tenants-button-renderer.component';

@Component({
    selector: 'app-project-grouproles-button-renderer',
    templateUrl: './project-grouproles-button-renderer.component.html',
    styleUrls: ['./project-grouproles-button-renderer.component.scss'],
    standalone: false
})
export class ProjectGrouprolesButtonRendererComponent implements ICellRendererAngularComp {

  params:any;

  icon_edit!: string;
  icon_delete!: string;
  icon_view!:string;
  //routerLinkEditTenantGroupRole!: string;
  tenantName!: string;
  tenantRoles: string[] = [];

  constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    public tenantService: TenantService,
    private notificationService: NotificationService,
    ) { }

  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;
    //this.routerLinkEditTenantGroupRole = _.isFunction(dataParams.routerLinkEditPlatformGroupRole) ? dataParams.routerLinkEditPlatformGroupRole(params) : _.get(params.data, dataParams.routerLinkEditGroupRole);
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    //console.log("------> project-group-roles-button-renderer paramns: ", this.params);


    //this.icon_edit = this.params.icon_edit || null;
    this.icon_delete = this.params.icon_delete || null;
    this.icon_view = this.params.icon_view || null;

    //this.routerLinkEditTenantGroupRole = this.params.routerLinkEditTenantGroupRole || null;
    this.refresh(params);

    this.tenantName = this.tenantService.currentTenantName;
    // this.tenantService.getToken(this.tenantName).subscribe({
    //   next:(token) =>{
    //     this.tenantRoles = this.tenantService.getTenantRoles(token);
    //     // console.log("------> tenant-group-roles-button-renderer tenant roles: ", this.tenantRoles);
    //   }
    // })
  }

  onClick($event: any) {
    if(this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component

      const params = {
        event: $event,
        rowData: this.params.node.data
      }
      this.params.onClick(this.params);
    }
  }

  viewProjectPermissions() {

    const rowData = [this.params.node.data]; 
    const tenantGroupRole = rowData[0];
    const groupRoleId = rowData[0].id;   
    console.log("------> viewProjectPermissions: groupRoleId = ", groupRoleId);

    const dialogRef = this.dialog.open(GroupRoleClaimsDialogComponent, { width: '500px', data: { roleId: groupRoleId, projectId:null , db:this.tenantName} });
    dialogRef.afterClosed().subscribe({
      next: () => {
        // this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["TENANTGROUPROLEDELETED"]} `);
        this.params.api.refreshInfiniteCache();
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTGROUPROLEDELETEDERROR"]}`)
    });
    this.params.api.refreshInfiniteCache();
    // this.tenantService.getTenantGroupRole(this.tenantService.tempTenant, tenantGrpRoleId, new GenericFilter()).subscribe({
    //   next: (tenantGroupRole) => {
    //     //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["PLATFORMPERMISSIONSRETRIEVED"]} `);
    //     this.dialog.open(ProjectPermissionsListComponent, {width: '500px', data:{tenantName: this.tenantService.tempTenant, tenantGroupRole: tenantGroupRole, tenantGroupRolePermissions: null, tenantRoles: this.tenantRoles}});
    //   },
    //   error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMPERMISSIONSRETRIEVEDERROR"]}`)
    // });
  }

  deleteProjectGroupRole(){
    const rowData = [this.params.node.data]; 
    let projectGroupRole = new ProjectGroupRoleDto;
    projectGroupRole.id = rowData[0].id;
    projectGroupRole.name = rowData[0].name;
    //projectGroupRole.projectId = rowData[0].projectId;
    //const tenantDb = localStorage.getItem('current-tenant-db') as string;
    console.log("deleteProjectGroupRole rowData=", rowData)

    const dialogRef = this.dialog.open(GroupRoleDeleteDialogComponent, { width: '500px', data: projectGroupRole});
    dialogRef.afterClosed().subscribe({
      next: () => {
        // this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["TENANTGROUPROLEDELETED"]} `);
        this.params.api.refreshInfiniteCache();
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTGROUPROLEDELETEDERROR"]}`)
    });
    this.params.api.refreshInfiniteCache();
  }
      
  openTenantGroupRoleDeleteDialog() {
    const rowData = [this.params.node.data]; 
    console.log(rowData[0]);
  }

}